import React, { useEffect, useState } from "react";
import logo from "../../../../assets/bluesky.png";
import { PiCopyDuotone } from "react-icons/pi";

export default function BlueskyPost({ masterPost }: { masterPost: string }) {
  const [post, setPost] = useState(masterPost);

  useEffect(() => {
    setPost(masterPost);
  }, [masterPost]);

  return (
    <div className="border rounded-md p-4">
      <div className="flex flex-row items-center gap-4 ">
        <img
          src={logo}
          className="m-0"
          alt="Bluesky"
          height={24}
          width={24}
        />
        <div className="p-0">Bluesky</div>
      </div>
      <textarea
        className="rounded-md textarea textarea-bordered p-4 w-full mt-4"
        placeholder="Write your post here"
        value={post}
        onChange={(e) => setPost(e.target.value)}
      ></textarea>
      <div className="flex flex-row items-center">
        <button
          className="btn"
          title="Copy Post"
          onClick={() => {
            navigator.clipboard.writeText(post);
          }}
        >
          <PiCopyDuotone size={24} />
        </button>
      </div>
    </div>
  );
}
